import {
  setCurArch,
  setdisabledLower,
  setdisabledUpper,
  setIsShowExtractedMsg,
  setOpenCollisionCheck,
  setTopLeftViewType,
} from "@/UDTreat/udTreatSlice"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  EArchType,
  gdsPlusSetup,
  stageControl,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { globalMovement } from "@/gluelayer/core/modules/globalMovement"
import { spaceManagement } from "@/gluelayer/core/modules/spaceManagement"
import { EArchForm, ESteupModelType, ETopLeftViewType } from "@/shared/types"
import utils from "@/shared/utils"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  CircularProgress,
} from "@mui/material"
import classNames from "classnames"
import { FC, useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import ArchForm from "./ArchForm"
import GlobalMovement from "./GlobalMovement"
import IPRSpaceManagement from "./IPRSpaceManagement"
import PonticDome from "./PonticDome"

interface IProps {
  curArch: string
}

const { setStageCallback, setStageStep, getWasmStageData } = stageControl

const MyAccordion: FC<IProps> = ({ curArch }) => {
  const dispatch = useDispatch()
  const MyCurArch = useRef<string>(curArch)
  const {
    openCollisionCheck,
    topLeftViewType,
    isShowExtractedMsg,
    updateStaging,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const timer = useRef<any>(null)

  const [expanded, setExpanded] = useState<ESteupModelType | null>(null)
  const [isShowPonticDome, setIsShowPonticDome] = useState(false)
  const [disabledGM, setDisabledGM] = useState<boolean>(false)
  const [isShowFinalStageModel, setIsShowFinalStageModel] =
    useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const [type, setType] = useState<EArchForm | null>(null)

  useEffect(() => {
    console.log(curArch, "=============")
    if (curArch === "up") {
      dispatch(setdisabledUpper(true))
      dispatch(setdisabledLower(false))
    }
    if (curArch === "low") {
      dispatch(setdisabledLower(true))
      dispatch(setdisabledUpper(false))
    }
    return () => {
      dispatch(setdisabledUpper(false))
      dispatch(setdisabledLower(false))
    }
  }, [curArch])

  /**
   * 校验是否有调整计划
   */
  const checkGMDisabled = (GMData) => {
    if (GMData) {
      if (GMData.jointUpKeypoints.length || GMData.jointLowerKeypoints.length) {
        setDisabledGM(false)
      } else {
        setDisabledGM(true)
      }
    }
  }

  /**
   * Set Final stage
   */
  const setFinalStage = () => {
    if (!wasmModule.isFinishedOpencase) return
    const stageController = wasmModule.ulabwinIns.getStageContoller()
    if (stageController) {
      for (let i = 0; i < 2; i++) {
        stageController.AutoStage(i)
      }
      stageController.FinalStage(0)
      stageController.FinalStage(1)
    }
  }

  /**
   * Arch Form
   */
  const initArchForm = (isInit: boolean) => {
    if (!isInit) {
      setType(null)
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
      gdsPlusSetup.EnterIPREditMode(false)
      return
    }
    setType(null)
    toothMovement.switchModuleFineTuneCircle(false)
    toothMovement.switchModuleFastSmartCircle(false)
    gdsPlusSetup.EnterIPREditMode(true)
  }

  /**
   * IPR Space Management
   */
  const initIPRModule = async (isInit: boolean) => {
    if (!isInit) {
      wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
      await utils.sleep(200)
      spaceManagement.SwitchModuleSpaceManagement(false)
      viewControlInTreatment.setViewType(ETopLeftViewType.FRONT)
      dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
      return
    }

    if (!spaceManagement.GetModuleSpaceManagement()) {
      initGDSModule(true)
    }
    // const type =
    //   curArch === "up"
    //     ? EShowArchType.UpArch
    //     : curArch === "low"
    //     ? EShowArchType.LowArch
    //     : EShowArchType.BothArch
    // console.log("=====Module init", spaceManagement.GetModuleSpaceManagement())
    // console.log("=====type", type)
    // const isFinalStage = spaceManagement.IsFinalStage(type)
    // if (!isFinalStage) {
    //   setIsShowFinalStageModel(true)
    //   return
    // }
    //如果是双颌，默认显示上颌 up, low, all
    if (curArch === "all") {
      dispatch(setCurArch("up"))
      MyCurArch.current = "up"
    }
    if (!openCollisionCheck) {
      dispatch(setOpenCollisionCheck(true))
    }
    await utils.sleep(200)
    dispatch(setTopLeftViewType(ETopLeftViewType.SPLIT))
    viewControlInTreatment.setViewType(ETopLeftViewType.SPLIT)
  }

  /**
   * Pontic Dome
   */
  const initPonticDomeModule = async (isInit: boolean) => {
    if (!isInit) {
      setIsShowPonticDome(false)
      wasmModule.statusController.SwitchDomePonticMenu(false)
      return
    }

    if (curArch === "all") {
      dispatch(setCurArch("up"))
      MyCurArch.current = "up"
    }
    if (openCollisionCheck) {
      dispatch(setOpenCollisionCheck(false))
    }
  }

  /**
   * Global Movement
   */
  const initGlobalMovement = async (isInit: boolean) => {
    MyCurArch.current = "all"
    dispatch(setCurArch("all"))
    dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
    viewControlInTreatment.setViewType(ETopLeftViewType.FRONT)
    if (!isInit) {
      if (isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(false))
      }

      toothMovement.setIsEnableMoveTooth(true)
      wasmModule.moduleManager.SwitchAttachmentModule(true)
      globalMovement.ToggleLowerArchMove(false)

      return
    }
    if (!isShowExtractedMsg) {
      dispatch(setIsShowExtractedMsg(true))
    }

    toothMovement.setIsEnableMoveTooth(false)
    wasmModule.moduleManager.SwitchAttachmentModule(false)
    globalMovement.ToggleLowerArchMove(true)
    setFinalStage()
  }

  // 监听Stage 变化，控制GM是否开启
  useEffect(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    // console.log("=============", hasUpper.GetTreatementType())
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (!hasUpper || !hasLower) {
      setDisabledGM(true)
      return
    } else {
      setDisabledGM(false)
    }

    const GMData = getWasmStageData()
    checkGMDisabled(GMData)
    timer.current = setInterval(() => {
      const GMData = getWasmStageData()
      checkGMDisabled(GMData)
    }, 1500)
    return () => {
      clearTimeout(timer.current)
      timer.current = null
    }
  }, [])

  /**
   * 监听modelType变化
   */
  useEffect(() => {
    if (!expanded) return
    const isSplitAndArch =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.ARCH_FORM
    const isSplitAndIPR =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT
    const isSplitAndPontic =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.PONTIC_DOME
    const isSplitAndGM =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.GLOBAL_MOVEMENT

    if (isSplitAndArch) {
      initArchForm(false)
    } else if (isSplitAndIPR) {
      // initIPRModule(false)
    } else if (isSplitAndPontic) {
      setIsShowPonticDome(false)
      wasmModule.statusController?.SwitchDomePonticMenu(false)
    } else if (isSplitAndGM) {
      // setExpanded(null)
      // initGlobalMovement(false)
      setExpanded(null)
      if (isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(false))
      }
      toothMovement.setIsEnableMoveTooth(true)
      wasmModule.moduleManager.SwitchAttachmentModule(true)
      globalMovement.ToggleLowerArchMove(false)
    }
  }, [expanded, topLeftViewType])

  const initView = async () => {
    MyCurArch.current = "all"
    dispatch(setCurArch("all"))
    dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
    await utils.sleep(0)
    if (wasmModule.isFinishedOpencase && wasmModule.moduleManager) {
      wasmModule.moduleManager?.SwitchModuleOrientationAdjustment(false)
      viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
    }
  }

  useEffect(() => {
    return () => {
      initArchForm(false)
      // IPR Space Management
      spaceManagement.SwitchModuleSpaceManagement(false)
      // Pontic Dome
      dispatch(setIsShowExtractedMsg(false))
      setIsShowPonticDome(false)
      toothMovement.setIsEnableMoveTooth(true)
      wasmModule.statusController?.SwitchDomePonticMenu(false)
      //GM
      initGlobalMovement(false)
      //关闭的时候初始化一下view
      initView()
    }
  }, [])

  //GM Close
  useEffect(() => {
    if (
      expanded === ESteupModelType.GLOBAL_MOVEMENT &&
      MyCurArch.current !== curArch
    ) {
      MyCurArch.current = curArch
      if (isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(false))
      }
      toothMovement.setIsEnableMoveTooth(true)
      wasmModule.moduleManager.SwitchAttachmentModule(true)
      globalMovement.ToggleLowerArchMove(false)
      setExpanded(null)
    }
  }, [curArch])

  /**
   * Init GDS
   */
  const initGDSModule = async (isOpen: boolean) => {
    spaceManagement.SwitchModuleSpaceManagement(isOpen)
  }

  /**
   * Init Status
   */
  const initStatus = async () => {
    if (
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded !== ESteupModelType.IPRN_SPACE_MANAGEMENT
    ) {
      await utils.sleep(200)
      dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
      wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
      viewControlInTreatment.setViewType(ETopLeftViewType.FRONT)
    }
  }

  const handleChange = async (panel: ESteupModelType, isExpanded: boolean) => {
    console.log("handleChange", expanded, panel, isExpanded, curArch)
    if (expanded && expanded !== panel) {
      if (expanded === ESteupModelType.ARCH_FORM) {
        initArchForm(false)
      } else if (expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
        initIPRModule(false)
      } else if (expanded === ESteupModelType.PONTIC_DOME) {
        if (isShowExtractedMsg) {
          dispatch(setIsShowExtractedMsg(false))
        }
        toothMovement.setIsEnableMoveTooth(true)
        setIsShowPonticDome(false)
        wasmModule.statusController.SwitchDomePonticMenu(false)
      } else if (expanded === ESteupModelType.GLOBAL_MOVEMENT) {
        initGlobalMovement(false)
      }
    }
    if (expanded === ESteupModelType.ARCH_FORM) {
      initArchForm(true)
    }

    if (panel === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
      initIPRModule(isExpanded)
    }
    if (panel === ESteupModelType.PONTIC_DOME) {
      initPonticDomeModule(isExpanded)
    }
    if (panel === ESteupModelType.GLOBAL_MOVEMENT) {
      initGlobalMovement(isExpanded)
    }

    setExpanded(isExpanded ? panel : undefined)
  }
  return (
    <>
      <Backdrop
        className="backdrop-common-style"
        sx={{ color: "#215ecd", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={pageLoading}
        onClick={() => setPageLoading(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/*Arch Form*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.ARCH_FORM,
        })}
        TransitionProps={{ unmountOnExit: true }}
        expanded={expanded === ESteupModelType.ARCH_FORM}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.ARCH_FORM, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="arch-form-header"
        >
          <h3 className="card-item-title">Arch Form</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <ArchForm curArch={curArch} setType={setType} type={type} />
        </AccordionDetails>
      </Accordion>

      {/*IPR / Space Management*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active":
            expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT,
        })}
        TransitionProps={{ unmountOnExit: true }}
        expanded={expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.IPRN_SPACE_MANAGEMENT, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="IPR-header"
        >
          <h3 className="card-item-title">IPR / Space Mgmt.</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <IPRSpaceManagement
            curArch={curArch}
            setPageLoading={setPageLoading}
          />
        </AccordionDetails>
      </Accordion>

      {/*Pontic / Dome*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.PONTIC_DOME,
        })}
        TransitionProps={{ unmountOnExit: true }}
        expanded={expanded === ESteupModelType.PONTIC_DOME}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.PONTIC_DOME, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="PD-header"
        >
          <h3 className="card-item-title">Pontic / Dome</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <PonticDome
            curArch={curArch}
            isShow={isShowPonticDome}
            setIsShow={setIsShowPonticDome}
          />
        </AccordionDetails>
      </Accordion>

      {/*Global Movement*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.GLOBAL_MOVEMENT,
        })}
        disabled={disabledGM}
        TransitionProps={{ unmountOnExit: true }}
        expanded={expanded === ESteupModelType.GLOBAL_MOVEMENT}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.GLOBAL_MOVEMENT, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="GM-header"
        >
          <h3 className="card-item-title">Global Movement</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <GlobalMovement setPageLoading={setPageLoading} />
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default MyAccordion
